import { HelmetProvider } from 'react-helmet-async';
import { RouterProvider } from 'react-router-dom';
import { FC } from 'react';

import { AuthLoader } from './AuthLoader';
import router from './router/router';
import { GlobalSeo } from './components/seo/GlobalSeo';

export const App: FC = () => {
  return (
    <HelmetProvider>
      <GlobalSeo />
      <AuthLoader>
        <RouterProvider router={router} />
      </AuthLoader>
    </HelmetProvider>
  );
};
